import 'intersection-observer';
import scrollama from '../../../node_modules/scrollama/build/scrollama.js';
import $ from 'jquery'
import { gsap } from 'gsap';

// -----
var scrollTimeout;
$(window).on('scroll', function() {
    clearTimeout(scrollTimeout);
    setTimeout(function(){
        if($(window).scrollTop() < 50){
            $('.header').removeClass('is-active');
            $('.header--inner').css({'height': '140px'});
            $('.header--bg').css({'height': 0});
        }else{
            $('.header').addClass('is-active');
            $('.header--inner').css({'height': '80px'});
            $('.header--bg').css({'height': '100%'});
        }
    }, 50);
});



// -----
if ($('.js-about').length) {
    const aboutScroller = scrollama();
    aboutScroller.setup({
        step: '.js-about'
    })
    .onStepEnter(response => {
        gsap.to('.js-about .split--image', { 
            width: '100%',
            height: '100%',
            opacity: 1,
            duration: 1,
            ease: 'Expo.easeOut'
        });
    })
    .onStepExit(response => {
        
    });
    window.addEventListener('resize', aboutScroller.resize);
}

// -----
if ($('.js-team').length) {
    const teamScroller = scrollama();
    teamScroller.setup({
        step: '.js-team'
    })
    .onStepEnter(response => {
        var id = $(response.element).attr('id');
        $('.js-team-to[href="#'+id+'"]').addClass('is-active');
    })
    .onStepExit(response => {
        var id = $(response.element).attr('id');
        $('.js-team-to[href="#'+id+'"]').removeClass('is-active');
    });
    window.addEventListener('resize', teamScroller.resize);
}
// -----